
export default {
    getDprHeader: (state) => state.dprHeader,
    getDprFileId: (state) => state.dprFileId,
    getCoords: (state) => state.coordinates,
    getDprHeaderNo: (state) => state.dprHeaderNo
}